<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>销售中心</el-breadcrumb-item>
      <el-breadcrumb-item>客户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>

    <!-- 筛选 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">信息筛选</span>
        </el-col>
      </el-row>
      <el-form :model="queryForm" class="filter_Form" label-width="100px" ref="queryFormRef">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="赛季" prop="season">
                <el-select
                    placeholder="请选择"
                    style="width: 100%"
                    v-model="queryForm.season"
                    clearable
                >
                    <el-option
                        v-for="item in dict_season"
                        :key="item.dictCode"
                        :label="item.dictLabel"
                        :value="item.dictValue"
                    ></el-option>
                </el-select>
            </el-form-item>
        </el-col>
          <el-col :span="6">
            <el-form-item label="赛区" prop="districtId">
              <el-select v-model="queryForm.districtId" placeholder="请选择赛区" clearable style="width: 100%">
                <el-option v-for="item in districtList" :key="item.id" :label="item.districtName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="客单状态" prop="guestStatus">
              <el-select v-model="queryForm.guestStatus" placeholder="请选择状态" clearable style="width: 100%">
                <el-option label="待跟进" :value="-1"></el-option>
                <el-option label="跟进中" :value="1"></el-option>
                <el-option label="已参赛" :value="2"></el-option>
                <el-option label="已拒绝" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="客户名称" prop="schoolName">
              <el-input v-model="queryForm.schoolName" placeholder="请输入客户名称" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button type="primary" style="width: 100%" @click="getDataList('search')">查询</el-button>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" plain style="width: 100%" @click="reset">重置</el-button>
        </el-col>
      </el-row>
    </el-card>
    <!-- 列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">客户列表</span>
        </el-col>
      </el-row>
      <el-table header-cell-class-name="tableHeaderStyle" :data="dataList" border stripe v-loading="loading">
        <el-table-column label="序号" type="index" width="60px"></el-table-column>
        <el-table-column label="客户名称" prop="school.schoolName" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.school.schoolName }}
            <div style="font-size: 10px; color: #999;">{{ formatAddress(scope.row.school) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="负责人" v-if="pageType === '1'" prop="recipientUser.userName"></el-table-column>
        <el-table-column label="客单状态">
          <template slot-scope="scope">
            <el-tag size="small" :type="guestStatusFilter(scope.row.guestStatus).type">{{ guestStatusFilter(scope.row.guestStatus).text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="客户类型" min-width="100">
          <template slot-scope="scope">{{ schoolTypeFilter(scope.row.school.schoolType) }}</template>
        </el-table-column>
        <el-table-column label="参赛类型">
          <template slot-scope="scope">{{ typeflagFilter(scope.row.school.typeflag) }}</template>
        </el-table-column>
        <el-table-column label="参赛经历">
          <template slot-scope="scope">{{ attendTypeFilter(scope.row.school.attendType) }}</template>
        </el-table-column>
        <el-table-column label="分配时间" prop="assigneeTime" min-width="160"></el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openTrackRecord(scope.row)">跟进记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="margin-top: 20px"
      ></el-pagination>
    </el-card>
    <SchoolTrackRecordDialog :visible.sync="trackRecordVisible" :row="currentRow" :schoolTypeList="schoolTypeList"></SchoolTrackRecordDialog>
  </div>
</template>
<script>
import { queryDistrictPage, getDictList } from '@/http/api'
import SchoolTrackRecordDialog from './components/SchoolTrackRecordDialog.vue'

export default {
  components: {
    SchoolTrackRecordDialog
  },
  data () {
    return {
      dict_season: this.$userInfo.getDataList(this, 't_season', this.$store.state.flag).then(value => { this.dict_season = value }),
      loading: false,
      total: 0,
      dataList: [],
      districtList: [],
      schoolTypeList: [],
      trackRecordVisible: false,
      currentRow: {},
      pageType: '1',
      queryForm: {
        season: this.$chnEngStatusCode.defaultSeason,
        districtId: '',
        guestStatus: '',
        schoolName: '',
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  watch: {
    trackRecordVisible (val) {
      if (!val) {
        this.getDataList()
      }
    }
  },
  created () {
    this.getDistrictList()
    this.pageType = this.$route.query.type || '1'
    this.getDataList()
    this.getSchoolTypeList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    // 获取赛区下拉列表
    getDistrictList () {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        if (res.code === 200) {
          this.districtList = res.data.list || []
        }
      }).catch((err) => {
        console.log('getDistrictList err', err)
      })
    },
    // 获取客户类型字典
    getSchoolTypeList () {
      getDictList({ dictType: 'school_type' }).then((res) => {
        if (res.code === 200) {
          this.schoolTypeList = res.data || []
        }
      }).catch((err) => {
        console.log('getSchoolTypeList err', err)
      })
    },
    // 地址拼接：省市区 + 详细地址
    formatAddress (row) {
      if (!row) return '-'
      const areaStr = [row.province, row.city, row.area].filter((v) => v).join('')
      return areaStr + (row.schoolAddress || '')
    },
    // 客单状态映射：-1待跟进 1跟进中 2已参赛 3已拒绝
    guestStatusFilter (val) {
      const map = {
        '-1': { text: '待跟进', type: 'warning' },
        1: { text: '跟进中', type: '' },
        2: { text: '已参赛', type: 'success' },
        3: { text: '已拒绝', type: 'danger' }
      }
      return map[String(val)] || { text: '未知', type: 'info' }
    },
    // 客户类型：动态字典 dictValue→dictLabel
    schoolTypeFilter (val) {
      const item = this.schoolTypeList.find((s) => String(s.dictValue) === String(val))
      return item ? item.dictLabel : '未知'
    },
    // 参赛类型：0非集体参赛 1集体参赛
    typeflagFilter (val) {
      const map = { 0: '非集体参赛', 1: '集体参赛' }
      return map[val] !== undefined ? map[val] : '未知'
    },
    // 参赛经历：0有参赛经历 1无参赛经历
    attendTypeFilter (val) {
      const map = { 0: '有参赛经历', 1: '无参赛经历' }
      return map[val] !== undefined ? map[val] : '未知'
    },
    // 跟踪记录
    openTrackRecord (row) {
      this.currentRow = row
      this.trackRecordVisible = true
    },
    // 获取跟进客户列表
    getDataList (getType) {
      if (getType === 'search') {
        this.queryForm.pageNum = 1
        this.queryForm.pageSize = 10
      }
      const params = {}
      Object.keys(this.queryForm).forEach((k) => {
        const v = this.queryForm[k]
        if (v !== '' && v !== null && v !== undefined) {
          params[k] = v
        }
      })
      this.loading = true
      const url = this.pageType === '1' ? 'schoolTrack/unFollowUp' : 'schoolTrack/assignedMyList'
      this.$http.get(url, { params }).then((res) => {
        if (res.code === 200) {
          this.dataList = res.data.list || []
          this.total = res.data.total || 0
        }
        this.loading = false
      }).catch((err) => {
        console.log('getDataList err', err)
        this.loading = false
        this.$message.error('获取列表失败')
      })
    },
    // 重置筛选条件
    reset () {
      this.$refs.queryFormRef.resetFields()
      this.getDataList()
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getDataList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getDataList()
    }
  }
}
</script>
<style lang="less" scoped>
</style>
